import React, {useMemo} from "react";
import {TabsSection, TabFormSection} from "./Styled";
import {FieldData} from "../../../containers/RegistrationLoginPage/types";
import {useSelector} from "react-redux";
import {RootStore} from "../../../configureStore";
import CurrentEducationUGSection from "./CurrentEducationUGSection";
import ExamSection from "./ExamSection";
import CurrentEducationMasterSection from "./CurrentEducationMasterSection";

interface CurrentEducationDetails {
    fields: FieldData;
    showPersonalSection: boolean;
}

const CurrentEducationWrapper: React.FC<CurrentEducationDetails> = ({
    fields,
    showPersonalSection,
}: CurrentEducationDetails) => {
    const level = useSelector((state: RootStore) => state.RegistrationLoginPage.level);
    const isMobile = useSelector((state: RootStore) => state.layout.isMobile);

    return useMemo(() => {
        return (
            <TabsSection>
                {!isMobile && (
                    <>
                        <h2>{!showPersonalSection ? `2` : `3`}. Current education details</h2>
                        <span>
                            Accurate details will help us show universities & scholarships that
                            match your profile.
                        </span>
                    </>
                )}

                {level === "Bachelors" ? (
                    <TabFormSection>
                        <CurrentEducationUGSection />
                    </TabFormSection>
                ) : level === "Masters" || level === "PhD" ? (
                    <TabFormSection>
                        <CurrentEducationMasterSection />
                    </TabFormSection>
                ) : null}
                <ExamSection fields={fields} level={level} />
            </TabsSection>
        );
    }, [level, fields, showPersonalSection, isMobile]);
};

export default CurrentEducationWrapper;
